// extracted by mini-css-extract-plugin
module.exports = {"icon":"PartnerIcon_icon__2qEff"};